import React from 'react';

import { AppModal } from 'src/components/AppModal';

export const ModalRequestCall: React.FC = () => {
  return (
    <AppModal
      open={false}
      toggleClose={() => null}
      contentHeader={<div />}
    >
      <>
        <div>
          asdasd
        </div>
      </>
    </AppModal>
  );
};
